
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function CaseStudiesHero() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="relative min-h-[70vh] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/91a46e13f952d6919b573c40fe874b4f.jpg"
          alt="Case Studies Hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-900/70 to-slate-900/50"></div>
      </div>

      <div
        ref={ref}
        className={`relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-32 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <span className="inline-block px-4 py-1.5 bg-[#00989e]/20 text-[#00b4a6] text-sm font-medium rounded-full mb-6">
          Our Portfolio
        </span>
        <h1 className="font-['Montserrat'] text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 max-w-4xl leading-tight">
          Client Success Stories
        </h1>
        <p className="text-xl text-gray-300 max-w-2xl mb-8">
          Discover how we&apos;ve helped brands transform their digital presence, 
          drive engagement, and achieve remarkable growth through strategic social media marketing.
        </p>
        <div className="flex flex-wrap gap-4">
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full">
            <i className="ri-briefcase-line text-[#00b4a6]"></i>
            <span className="text-white text-sm">50+ Projects Delivered</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full">
            <i className="ri-line-chart-line text-[#00b4a6]"></i>
            <span className="text-white text-sm">Average 3x ROI</span>
          </div>
          <div className="flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full">
            <i className="ri-heart-line text-[#00b4a6]"></i>
            <span className="text-white text-sm">98% Client Satisfaction</span>
          </div>
        </div>
      </div>
    </section>
  );
}
